import { render, staticRenderFns } from "./ChatSettingForm.vue?vue&type=template&id=6493deab&scoped=true&"
import script from "./ChatSettingForm.vue?vue&type=script&lang=js&"
export * from "./ChatSettingForm.vue?vue&type=script&lang=js&"
import style0 from "./ChatSettingForm.vue?vue&type=style&index=0&id=6493deab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6493deab",
  null
  
)

export default component.exports